import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthModalComponent } from './components/auth-modal/auth-modal.component';
import { InstallationModalComponent } from './components/installation-modal/installation-modal.component';
import { PromoDialogComponent } from './components/promo-dialog/promo-dialog.component';
import { CartDetailDialogComponent } from './components/cart-detail-dialog/cart-detail-dialog.component';
import { AddressDialogComponent } from './components/address-dialog/address-dialog.component';
import { SimilarDialogComponent } from './components/similar-dialog/similar-dialog.component';
import { CardSkeletonComponent } from './components/card-skeleton/card-skeleton.component';

// Pages
import { HomeComponent } from './pages/home/home.component';
import { ListingComponent } from './pages/listing/listing.component';
import { PdpComponent } from './pages/pdp/pdp.component';
import { CartComponent } from './pages/cart/cart.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { CustomUploadComponent } from './pages/custom-upload/custom-upload.component';
import { CustomDesignComponent } from './pages/custom-design/custom-design.component';
import { NurComponent } from './pages/nur/nur.component';
import { PrintFrameComponent } from './pages/print-frame/print-frame.component';
import { CollageSetComponent } from './pages/collage-set/collage-set.component';
import { CollageSetDetailComponent } from './pages/collage-set-detail/collage-set-detail.component';
import { UploadDialogComponent } from './components/upload-dialog/upload-dialog.component';
import { PricingDetailDialogComponent } from './components/pricing-detail-dialog/pricing-detail-dialog.component';
import { ArtReadyComponent } from './pages/art-ready/art-ready.component';
import { WallArtComponent } from './pages/wall-art/wall-art.component';
import { ArtSearchComponent } from './pages/art-by-search/art-search.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
// PaymentSuccess stays deleted (old PayU hook); PaymentFailed rebuilt for Razorpay.
import { PaymentFailedComponent } from './pages/payment-failed/payment-failed.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { FindArtComponent } from './pages/find-art/find-art.component';
import { OnSaleDetailComponent } from './pages/featured-art-details/on-sale-detail.component';
import { ProductCustomizationComponent } from './pages/product-customization/product-customization.component';
import { ValidationDialogComponent } from './components/validation-dialog/validation-dialog.component';
import { CategoryListingComponent } from './pages/category-listing/category-listing.component';
import { FeaturedFramesComponent } from './pages/featured-frames/featured-frames.component';
import { FeaturedFrameDetailComponent } from './pages/featured-frame-detail/featured-frame-detail.component';
import { ArtForBusinessComponent } from './pages/art-for-business/art-for-business.component';
import { FaqComponent } from './pages/faq/faq.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { ReturnPolicyComponent } from './pages/return-policy/return-policy.component';
import { PrintingPartnerComponent } from './pages/printing-partner/printing-partner.component';
import { CareerComponent } from './pages/career/career.component';
import { SpaceListingComponent } from './pages/space-listing/space-listing.component';
import { LandingComponent } from './pages/landing/landing.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AuthModalComponent,
    InstallationModalComponent,
    PromoDialogComponent,
    CartDetailDialogComponent,
    AddressDialogComponent,
    SimilarDialogComponent,
    CardSkeletonComponent,
    HomeComponent,
    ListingComponent,
    PdpComponent,
    CartComponent,
    WishlistComponent,
    CustomUploadComponent,
    CustomDesignComponent,
    NurComponent,
    PrintFrameComponent,
    CollageSetComponent,
    CollageSetDetailComponent,
    UploadDialogComponent,
    PricingDetailDialogComponent,
    ArtReadyComponent,
    WallArtComponent,
    ArtSearchComponent,
    CheckoutComponent,
    ThankYouComponent,
    PaymentFailedComponent,
    AboutComponent,
    ContactComponent,
    PartnersComponent,
    FindArtComponent,
    OnSaleDetailComponent,
    ProductCustomizationComponent,
    ValidationDialogComponent,
    CategoryListingComponent,
    FeaturedFramesComponent,
    FeaturedFrameDetailComponent,
    ArtForBusinessComponent,
    FaqComponent,
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    ReturnPolicyComponent,
    PrintingPartnerComponent,
    CareerComponent,
    SpaceListingComponent,
    LandingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ImageCropperModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
